import { Salesunit} from './salesunit.model';
import { Contact} from './contact.model';
import { JsonProperty} from 'json-typescript-mapper';
import { Contract} from './contract.model';
import { Marketdate} from './marketdate.model';
import { GeoEntity } from './geo-entity.model';
import { DiscountType } from './discount.model';
import {User} from './user.model';

export enum Status {
  None = <any>'None',
  Absent = <any>'Absent',
  Completed = <any>'Completed',
  Payment = <any>'Payment'
};

export enum ContractType {
  Standard = <any>'Standard',
  None = <any>'None'
};

export enum EnergyPriceType {
  Null = <any>'Null',
  None = <any>'None',
  Low = <any>'Low',
  Normal = <any>'Normal',
  Special = <any>'Special',
  Unknown = <any>'Unknown',
  ContractDivergentNone = <any>'ContractDivergentNone',
  ContractUnchanged = <any>'ContractUnchanged'
};

export enum SqmAdditionalType {
  Null = <any>'Null',
  HighTable = <any>'HighTable',
  ProductCarriers = <any>'ProductCarriers',
  CoatRack = <any>'CoatRack',
  FloorArea = <any>'FloorArea',
  OtherArea = <any>'OtherArea'
}

export class Booth {

  @JsonProperty('id')
  public id?: number;

  @JsonProperty('contractType')
  public contractType?: ContractType;

  @JsonProperty('order')
  public order?: number;

  @JsonProperty({clazz: Salesunit, name: 'salesunit'})
  public salesunit?: Salesunit;

  @JsonProperty({clazz: Contact, name: 'contactPerson'})
  public contactPerson?: Contact;

  @JsonProperty({clazz: Contract, name: 'contract'})
  public contract?: Contract;

  @JsonProperty({clazz: Contact, name: 'merchant'})
  public merchant?: Contact;

  @JsonProperty({clazz: Marketdate, name: 'marketdate'})
  public marketdate?: Marketdate;

  @JsonProperty('width')
  public width?: number;

  @JsonProperty('depth')
  public depth?: number;

  @JsonProperty('widthAdditional')
  public widthAdditional?: number;

  @JsonProperty('depthAdditional')
  public depthAdditional?: number;

  @JsonProperty('sqmCost')
  public sqmCost?: number;

  @JsonProperty('sqmCostIncludingBase')
  public sqmCostIncludingBase?: number;

  @JsonProperty('sqmCostIncludingAdditionalFeeCash')
  public sqmCostIncludingAdditionalFeeCash?: number;

  @JsonProperty('energyPriceType')
  public energyPriceType?: EnergyPriceType;

  @JsonProperty('energyPriceTypeDivergent')
  public energyPriceTypeDivergent?: EnergyPriceType;

  @JsonProperty('energyPrice')
  public energyPrice?: number;

  @JsonProperty('priceSanitary')
  public priceSanitary?: number;

  @JsonProperty('priceCleaning')
  public priceCleaning?: number;

  @JsonProperty('priceParking')
  public priceParking?: number;

  @JsonProperty('marketingFee')
  public marketingFee?: number;

  @JsonProperty('permanentMarketingFee')
  public permanentMarketingFee?: number;

  @JsonProperty('priceTotal')
  public priceTotal?: number;

  @JsonProperty('status')
  public status?: Status;

  @JsonProperty('noPaymentReceived')
  public noPaymentReceived?: boolean;

  @JsonProperty('noPaymentReceivedReason')
  public noPaymentReceivedReason?: string;

  @JsonProperty('partialPaymentReceived')
  public partialPaymentReceived?: boolean;

  @JsonProperty('partialPayment')
  public partialPayment?: number;

  @JsonProperty('sqmAdditionalType')
  public sqmAdditionalType?: SqmAdditionalType;

  @JsonProperty('openPaymentSettled')
  public openPaymentSettled?: number;

  @JsonProperty('absentMessage')
  public absentMessage?: string;

  @JsonProperty('priceCategory')
  public priceCategory?: string;

  @JsonProperty('pricePerUnit')
  public pricePerUnit?: number;

  @JsonProperty('lastStatus')
  public lastStatus?: Status;

  @JsonProperty('lastAccount')
  public lastAccount?: Status;

  @JsonProperty({clazz: GeoEntity, name: 'geoEntity'})
  public geoEntity?: GeoEntity;

  @JsonProperty('discount')
  public discount?: number;

  @JsonProperty('discountType')
  public discountType?: DiscountType;

  @JsonProperty('discountPercentage')
  public discountPercentage?: number;

  @JsonProperty('basicCharges')
  public basicCharges?: number;

  @JsonProperty('suBoothWidth')
  public suBoothWidth?: number;

  @JsonProperty('suBoothWidthWinter')
  public suBoothWidthWinter?: number;

  @JsonProperty('suBoothDepth')
  public suBoothDepth?: number;

  @JsonProperty('suBoothDepthWinter')
  public suBoothDepthWinter?: number;

  @JsonProperty('suEnergyType')
  public suEnergyType?: string;

  @JsonProperty('suEnergyTypeWinter')
  public suEnergyTypeWinter?: string;

  @JsonProperty('suEnergyPrice')
  public suEnergyPrice?: number;

  @JsonProperty('suAssortment')
  public suAssortment?: string;

  @JsonProperty('suAssortmentAdditional')
  public suAssortmentAdditional?: string;

  @JsonProperty('suAssortmentExtended')
  public suAssortmentExtended?: string;

  @JsonProperty('suAssortmentExtendedAdditional')
  public suAssortmentExtendedAdditional?: string;

  @JsonProperty('cpDisplayname')
  public cpDisplayname?: string;

  @JsonProperty('cpFunction')
  public cpFunction?: string;

  @JsonProperty('cpMobile')
  public cpMobile?: string;

  @JsonProperty('meNumber')
  public meNumber?: string;

  @JsonProperty('meCompany')
  public meCompany?: string;

  @JsonProperty('meCompanyAdditional')
  public meCompanyAdditional?: string;

  @JsonProperty('ctBoothWidth')
  public ctBoothWidth?: number;

  @JsonProperty('ctBoothWidthWinter')
  public ctBoothWidthWinter?: number;

  @JsonProperty('ctBoothWidthAdditional')
  public ctBoothWidthAdditional?: number;

  @JsonProperty('ctBoothWidthWinterAdditional')
  public ctBoothWidthWinterAdditional?: number;

  @JsonProperty('ctBoothDepth')
  public ctBoothDepth?: number;

  @JsonProperty('ctBoothDepthWinter')
  public ctBoothDepthWinter?: number;

  @JsonProperty('ctBoothDepthAdditional')
  public ctBoothDepthAdditional?: number;

  @JsonProperty('ctBoothDepthWinterAdditional')
  public ctBoothDepthWinterAdditional?: number;

  @JsonProperty('ctEnergyType')
  public ctEnergyType?: string;

  @JsonProperty('ctEnergyTypeWinter')
  public ctEnergyTypeWinter?: string;

  @JsonProperty('ctUseWinterSize')
  public ctUseWinterSize?: boolean;

  @JsonProperty('ctUseAddtitionalWinterSize')
  public ctUseAddtitionalWinterSize?: boolean;

  @JsonProperty('ctSalesunitNumber')
  public ctSalesunitNumber?: string;

  @JsonProperty('ctSalesunitIdentification')
  public ctSalesunitIdentification?: string;

  @JsonProperty({clazz: User, name: 'updatedBy'})
  public updatedBy?: User;

  @JsonProperty('accountedAt')
  public accountedAt?: any;

  @JsonProperty('addedManually')
  public addedManually?: any;

  constructor() {
    this.id = void 0;
    this.contractType = void 0;
    this.order = void 0;
    this.salesunit = void 0;
    this.contactPerson = void 0;
    this.contract = void 0;
    this.marketdate = void 0;

    this.width = 0;
    this.depth = 0;
    this.widthAdditional = 0;
    this.depthAdditional = 0;
    this.sqmCost = 0;
    this.sqmCostIncludingBase = 0;
    this.sqmCostIncludingAdditionalFeeCash = 0;
    this.energyPriceType = EnergyPriceType.Normal;
    this.energyPriceTypeDivergent = void 0;
    this.energyPrice = 0;

    this.priceSanitary = 0;
    this.priceCleaning = 0;
    this.priceParking = 0;

    this.marketingFee = 0;
    this.permanentMarketingFee = 0;
    this.priceTotal = 0;

    this.status = Status.None;

    this.merchant = void 0;

    this.noPaymentReceived = false;
    this.noPaymentReceivedReason = void 0;

    this.partialPaymentReceived = false;
    this.partialPayment = void 0;

    this.sqmAdditionalType = SqmAdditionalType.Null;

    this.openPaymentSettled = void 0;

    this.absentMessage = void 0;

    this.priceCategory = void 0;
    this.pricePerUnit = void 0;

    this.lastAccount = void 0;
    this.lastStatus = void 0;

    this.geoEntity = void 0;

    this.discountPercentage = void 0;
    this.discount = void 0;
    this.discountType = void 0;

    this.basicCharges = void 0;

    this.updatedBy = void 0;
    this.accountedAt = void 0;

    this.suBoothWidth = void 0;
    this.suBoothWidthWinter = void 0;
    this.suBoothDepth = void 0;
    this.suBoothDepthWinter = void 0;
    this.suEnergyType = void 0;
    this.suEnergyTypeWinter = void 0;
    this.suEnergyPrice = void 0;
    this.suAssortment = void 0;
    this.suAssortmentAdditional = void 0;
    this.suAssortmentExtended = void 0;
    this.suAssortmentExtendedAdditional = void 0;
    this.cpDisplayname = void 0;
    this.cpFunction = void 0;
    this.cpMobile = void 0;
    this.meNumber = void 0;
    this.meCompany = void 0;
    this.meCompanyAdditional = void 0;
    this.ctBoothWidth = void 0;
    this.ctBoothWidthWinter = void 0;
    this.ctBoothWidthAdditional = void 0;
    this.ctBoothWidthWinterAdditional = void 0;
    this.ctBoothDepth = void 0;
    this.ctBoothDepthWinter = void 0;
    this.ctBoothDepthAdditional = void 0;
    this.ctBoothDepthWinterAdditional = void 0;
    this.ctEnergyType = void 0;
    this.ctEnergyTypeWinter = void 0;
    this.ctUseWinterSize = void 0;
    this.ctUseAddtitionalWinterSize = void 0;
    this.ctSalesunitNumber = void 0;
    this.ctSalesunitIdentification = void 0;

  }
}



// WEBPACK FOOTER //
// ./src/app/entities/booth.model.ts